module.exports = __webpack_public_path__ + "static/cases-tile-4-3-1016c5bfa22fbed9dd36e2d6f606d53d.png";